(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      // 11NIL: skip other colors of the style being viewed, show one color per style, cap at the section's max
      var styleOf = function (t) { return (t || '').split(' - ')[0].replace(/\s+/g, ' ').trim().toUpperCase(); };
      var titleEl = document.querySelector('.section-main-product .title-row') || document.querySelector('h1');
      var current = styleOf(titleEl ? titleEl.textContent : '');
      var max = parseInt(productRecommendationsSection.dataset.max || '4', 10);
      var seen = {}, shown = 0;
      productRecommendationsSection.querySelectorAll('product-block, .product-block').forEach(function (b) {
        var t = b.querySelector('.product-block__title');
        var st = styleOf(t ? t.textContent : '');
        if ((current && st === current) || seen[st] || shown >= max) { b.remove(); return; }
        seen[st] = true; shown++;
      });
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
